export const newsTranslations = {
  NEWS_TITLE: 'News',
  NEWS_SUBTITLE: 'Tranzer in the media!'
};
